import {Map, fromJS, List} from "immutable";

import {FETCH_TRANSPORTATION_REQUEST, FETCH_TRANSPORTATION_SUCCESS, FETCH_TRANSPORTATION_ERROR, CLEAN_TRANSPORTATION_STATE} from "./transportation-actions"

const transportation = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        case FETCH_TRANSPORTATION_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        case FETCH_TRANSPORTATION_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        case FETCH_TRANSPORTATION_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        case CLEAN_TRANSPORTATION_STATE:
            newState = state.merge({
                payload: undefined,
                isFetching: false,
                error: false
            });
            return newState;

        default:
            return state;
    }
};

export default transportation;
